import React, {
  FC,
} from 'react';
import {
  ColumnCenter,
} from '../../Styles';
import { getWindowWidth, isMobile } from '../../../../../../../lib/utils/utils';
import InterMediumText from '../../../../../../../components/Text/InterMediumText';
import PingFangMediumText from '../../../../../../../components/Text/PingFangMediumText';
import Input from '../../../../../../../components/Input';

const Email: FC<Props> = ({
  isEnglish,
  formError,
  email,
  setEmail,
}) => {
  const inputWidth = isMobile() ? getWindowWidth() - 40 : 400;
  return (
    <div style={{ marginTop: 30 }}>
      <div style={{ width: isMobile() ? getWindowWidth() - 40 : 400, marginLeft: 'auto', marginRight: 'auto', textAlign: 'center' }}>
        {
          isEnglish ? (
            <InterMediumText fontSize={16} lineHeight={22}>
              Email address
            </InterMediumText>
          ) : (
            <PingFangMediumText fontSize={16} color={'#000000'}>
              电子邮箱
            </PingFangMediumText>
          )
        }
      </div>

      {/* 电子邮箱输入框 */}
      <ColumnCenter style={{ height: 60, width: inputWidth, marginLeft: 'auto', marginRight: 'auto', alignItems: 'center', backgroundColor: 'rgba(228, 228, 228, 0.5)', borderRadius: 5, marginTop: 10 }}>
        {
          <Input
            style={{
              border: 'none',
              outline: 'none',
              fontSize: '18px',
              fontFamily: 'Inter-Regular, Inter',
              fontWeight: 400,
              color: '#000000',
              backgroundColor: 'transparent',
              lineHeight: '35px',
              width: inputWidth - 20,
              textAlign: 'center',
            }}
            placeholder={'address@email.com'}
            placeFontFamily={'Inter-Regular, Inter'}
            placeholderColor={'rgba(0, 0, 0, 0.5)'}
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
        }
      </ColumnCenter>
    </div>
  );
};

export interface Props {
  isEnglish: boolean;
  formError: boolean;
  email?: string;
  setEmail: (email: string) => void;
}

export default Email;
